import { render, staticRenderFns } from "./TabBank.vue?vue&type=template&id=5912bf7e&"
import script from "./TabBank.vue?vue&type=script&lang=js&"
export * from "./TabBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports